import axios from 'axios'
import React from 'react'
import { toast } from "react-toastify";

function ExportExcel() {


    async function handleButtonClick(event){
        event.preventDefault();
        try {
            const url = axios.defaults.baseURL + "/api/smartreporting/export_excel/"
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = "report.xlsx";
                    document.body.appendChild(a); 
                    a.click();    
                    toast("Downloaded...");
                    a.remove(); 
                });
        }
        catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <button className="btn btn-dark" onClick={handleButtonClick}>Excel</button>
        </>
    )
}

export default ExportExcel